import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PRODUCTION_PROGRESS',
    url: '',
  });

  const fetchData = function () {
    let url = '/api/product_progress_statistical';
    if (param) {
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${param[key]}`;
      });
      exec(url);
    } else {
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [isRequestSuccessed, data || {}, fetchData];
});
